// Aboutus.js
import React from 'react';
import './aboutus.css';
import { FaBullseye, FaEye } from "react-icons/fa";
import { FaHeart, FaAward, FaUsers } from "react-icons/fa";


function Aboutus() {
  return (
    <div className="aboutus-page">
      <div className="aboutus-container">
        {/* Hero Section */}
        <div className="about-hero">
          <div className="hero-content">
            <div className="lions-badge">Sri Lanka's First Specialised Eye Care Lions Club</div>
            <h1>Lions Club of Colombo Eye Care</h1>
            <p className="hero-subtitle">
             
            </p>
          </div>
        </div>

        {/* Main Content */}
        <div className="about-content">
          {/* Introduction */}
          <div className="intro-section">
            <h2 className="section-title">Our Story</h2>
            <p className="section-subtitle">
              A legacy of service, Eye Care, and community impact
            </p>
            <p style={{ fontSize: '1.1rem', lineHeight: '1.8', color: '#334155' }}>
              Welcome to the Lions Club of Colombo Eye Care, where compassion meets expertise. 
              As Sri Lanka's first specialised Lions club focused on eye care, we have been 
              at the forefront of Eye health services since our inception. Our dedicated 
              team of professionals and volunteers work tirelessly to ensure that quality 
              eye care is accessible to all members of our community.
            </p>
          </div>

          {/* Mission & Vision Cards */}
  <section className="mission-vision-section">
      <div className="section-header">
        <h2>
          Our <span>Mission & Vision</span>
        </h2>
        <p>Committed to improving eye health and vision care in Sri Lanka</p>
      </div>

      <div className="mission-vision-grid">
        <div className="mv-card">
          <div className="card-icon">
            <FaBullseye />
          </div>
          <h3>Our Mission</h3>
          <p>
            To provide accessible, high-quality eye care services to the community, 
            prevent blindness, and improve quality of life for those with vision 
            impairments through dedicated service and advanced medical care.
          </p>
        </div>

        <div className="mv-card">
          <div className="card-icon">
            <FaEye />
          </div>
          <h3>Our Vision</h3>
          <p>
            A Sri Lanka where everyone has access to quality eye care, and no one 
            suffers from preventable blindness. We envision communities with healthy 
            vision and empowered individuals leading fulfilling lives.
          </p>
        </div>
      </div>
    </section>

          {/* Stats Section */}
          <div className="stats-grid">
            <div className="stat-item">
              <div className="stat-number">8+</div>
              <div className="stat-label">Years of Service</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">5000+</div>
              <div className="stat-label">Patients Treated</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">100+</div>
              <div className="stat-label">Community Programs</div>
            </div>
          </div>

          {/* History Timeline */}
          <div className="history-section">
            <h2 className="section-title">Our Journey</h2>
            <div className="timeline">
              <div className="timeline-item">
                <div className="timeline-year">2014</div>
                <div className="timeline-content">
                  <h4>Foundation</h4>
                  <p>Lions Club of Colombo Eye Care established as Sri Lanka's first specialised eye care Lions club</p>
                </div>
              </div>
              <div className="timeline-item">
                <div className="timeline-year">2015</div>
                <div className="timeline-content">
                  <h4>Eye Clinic Center Launch</h4>
                  <p>Opened our first dedicated eye care facility in Colombo</p>
                </div>
              </div>
              <div className="timeline-item">
                <div className="timeline-year">2015</div>
                <div className="timeline-content">
                  <h4>Mobile Eye Care Unit</h4>
                  <p>Launched mobile services to reach rural communities</p>
                </div>
              </div>
              <div className="timeline-item">
                <div className="timeline-year">2024</div>
                <div className="timeline-content">
                  <h4>10th Anniversary</h4>
                  <p>Celebrating 10 years of dedicated eye care service to the nation</p>
                </div>
              </div>
            </div>
          </div>

          {/* Core Values */}
    <section className="values-section">
      <h2 className="section-title">Our Values</h2>

      <div className="values-grid">
        <div className="value-card">
          <div className="value-icon">
            <FaHeart />
          </div>
          <h4>Compassion</h4>
          <p>We treat every patient with empathy, dignity, and respect</p>
        </div>

        <div className="value-card">
          <div className="value-icon">
            <FaAward />
          </div>
          <h4>Excellence</h4>
          <p>We strive for the highest standards in eye care services</p>
        </div>

        <div className="value-card">
          <div className="value-icon">
            <FaUsers />
          </div>
          <h4>Community</h4>
          <p>We believe in serving and strengthening our communities</p>
        </div>
      </div>
    </section>



    

          {/* Team Section */}
          <div className="team-section">
            <h2 className="section-title">Leadership Team</h2>
            <div className="team-grid">
              <div className="team-member">
                <div className="member-image"></div>
                <div className="member-info">
                  <h4>Dr. Kamal Perera</h4>
                  <div className="position">President</div>
                  <p className="bio">Leading with vision and compassion since 2010</p>
                </div>
              </div>
              <div className="team-member">
                <div className="member-image"></div>
                <div className="member-info">
                  <h4>Dr. Nimali Fernando</h4>
                  <div className="position">Medical Director</div>
                  <p className="bio">Specialist in ophthalmology with 20+ years experience</p>
                </div>
              </div>
              <div className="team-member">
                <div className="member-image"></div>
                <div className="member-info">
                  <h4>Mr. Sunil Wijesinghe</h4>
                  <div className="position">Secretary</div>
                  <p className="bio">Dedicated to community outreach and service</p>
                </div>
              </div>
              <div className="team-member">
                <div className="member-image"></div>
                <div className="member-info">
                  <h4>Ms. Priya Rajapakse</h4>
                  <div className="position">Treasurer</div>
                  <p className="bio">Ensuring resources serve our mission effectively</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Call to Action */}
        <div className="about-cta">
          <div className="cta-content">
            <h2>Join Our Mission</h2>
            <p>Be part of our journey to provide quality eye care to all Sri Lankans</p>
            <a href="/get-involved-today" className="cta-button">
              Get Involved Today
              <span>→</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Aboutus;